/**
 * Dependencies.
 */
import AddressReverseModel from '@/api/address/reverse.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class AddressReverseService extends BaseService<AddressReverseModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      AddressReverseModel,
      AddressReverseModel.name,
      applicationConstant.apiCustomerPublicUrl
    );
  }
}

/**
 * Export `addressReverseService`.
 */
export const addressReverseService = new AddressReverseService();
